// src/utils/util.js

// Reference: https://www.npmjs.com/package/libphonenumber-js
import parsePhoneNumber from 'libphonenumber-js'
import axios from 'axios'

const headers = {
  'Content-Type': 'application/x-www-form-urlencoded',
  'Access-Control-Allow-Origin': '*'
}

export default {
  headers,

  getDate: function(date, days) {
    if (days) this.setDate(date, days)
    let m = String(date.getMonth() + 101).substring(1, 3)
    let d = String(date.getDate() + 100).substring(1, 3)
    return date.getFullYear() + '-' + m + '-' + d
  },

  setDate: function(date, days) {
    date.setDate(date.getDate() + days);
  },

  getDayOfWeek: function(date) {
    let day = new Date(date).getDay()
    return ['일', '월', '화', '수', '목', '금', '토'][day]
  },

  getTime12: function(time) {
    return new Date('2000-01-01T' + time).toLocaleString([], { hour12: true})
    .replace('2000. 1. 1. ', '')
    .replace(':00', '')
  },

  getDateOfWeek: function(date, day) {
    return this.getDate(new Date(date.setDate(date.getDate() - date.getDay() + day)))
  },

  getDateOfMonth: function(date, month) {
    return this.getDate(new Date(date.getFullYear(), date.getMonth() + month, month ? 0 : 1))
  },

  getPhoneNumber: function (number) {
    if (number.length < 10) return 'N/A'
    let phoneNumber = parsePhoneNumber(number, 'KR')
    if (phoneNumber)
      return phoneNumber.formatNational()
    return 'N/A'
  },
  
  getItem: function (items, id) {
    let item = items.find(item => item.value === id)
    return item ? item : { value: 0, text: '알 수 없음 (' + id + ')' }
  },

  getStudios: function (callback) {
    axios.get('/api/studio/list')
    .then(response => {
      let items = []
      if (response.data.error)
        callback(items, response.data.error)
      else {
        response.data.list.forEach(item => {
          items.push({
            value: item.id,
            text: item.name,
            link: item.link,
            phone: item.phone,
            address: item.address
          })
        })
        callback(items)
      }
    })
  },

  getLevels: function (callback) {
    axios.get('/api/user/level')
    .then(response => {
      let items = []
      if (response.data.error)
        callback(items, response.data.error)
      else {
        response.data.list.forEach(item => {
          items.push({
            value: item.id,
            text: item.name
          })
        })
        callback(items)
      }
    })
  },
  
  getCoupon: function (id, callback) {
    axios.get(`/api/user/coupon/${id}`)
    .then(response => {
      if (response.data.error) {
        callback(null, response.data.error)
        return
      }
      let coupon = response.data.coupon
      if (coupon && coupon.days >= 0) {     
        callback(coupon)
      }
      else {
        callback(null, 'No coupon')
      }
    })
  },

  isAndroid: function () {
    let IorA = navigator.userAgent.toLowerCase()
    return IorA.indexOf("android") > 0
  }
}

// End of util.js